!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {


  });

}(jQuery);

window.$ = jQuery;



